import { render } from "./AddRoleModal.vue?vue&type=template&id=ed5c4d58&scoped=true&ts=true"
import script from "./AddRoleModal.vue?vue&type=script&lang=ts"
export * from "./AddRoleModal.vue?vue&type=script&lang=ts"

import "./AddRoleModal.vue?vue&type=style&index=0&id=ed5c4d58&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed5c4d58"]])

export default __exports__